skrilla.controller('withdrawalDetailsCtrl', function ($scope, searchService, $stateParams) {
   searchService.get('withdrawals/' + $stateParams.id).then(function(response){
       $scope.withdrawal = response.data;
   });
});

